import React from 'react';

interface BorderDateSelectProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  className?: string;
  label?: string;
  showIcon?: boolean;
  disabled?: boolean;
}

const BorderDateSelect: React.FC<BorderDateSelectProps> = ({
  error,
  className,
  label,
  showIcon = true,
  disabled = false,
  ...inputProps
}) => {
  return (
    <div className="border-date-select flex flex-col relative">
      <style>
        {`
            .border-date-select input[type="date"] {
                position: relative;
            }
            .border-date-select input[type="date"]::-webkit-calendar-picker-indicator {
                opacity: 0;
                cursor: pointer;
                position: absolute;
                inset: 0;
                width: 100%;
                height: 100%;
            }
        `}
      </style>
      {label && (
        <label className="absolute -top-2 left-3 mb-1 text-xs font-light text-gray-500">
          {label}
        </label>
      )}
      <div
        className={`group relative rounded cursor-pointer ${error ? 'border-red-500' : ''} ${className || ''}`}
        style={{
          paddingLeft: '1px',
          paddingRight: '5px',
          display: 'inline-block',
          maxWidth: showIcon ? '170px' : '120px',
          maxHeight: 40,
        }}
      >
        {/* Calendar icon left-aligned */}
        <span className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500 z-10">
          {showIcon && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="18"
                rx="2"
                fill="none"
                stroke="currentColor"
              />
              <path
                d="M16 2v4M8 2v4M3 10h18"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
              />
            </svg>
          )}
        </span>
        <input
          type="date"
          disabled={disabled}
          className={`
            appearance-none bg-transparent w-full pr-3 py-5 rounded transition-all duration-300
            border-1 border-transparent 
            group-hover:border-gray-500 
            group-hover:border 
            focus:outline-none
            focus:border-blue-500
            ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
            cursor-pointer
            h-12
            ${showIcon ? 'pl-10' : 'pl-2'}
            ${error ? 'group-hover:border-red-500 group-focus-within:border-red-500 border border-red-500' : ''}
          `}
          style={{
            maxHeight: 36,
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            appearance: 'none',
            position: 'relative',
            zIndex: 1,
          }}
          {...inputProps}
        />
      </div>
      {error && (
        <span className="mt-1 text-xs text-red-500">
          {error}
        </span>
      )}
    </div>
  );
};

export default BorderDateSelect;
